module.exports = __webpack_public_path__ + "resource/img/image037Dark.e912e8b5.png";